/**
 * Arquivo de Configuração de Conteúdo Dinâmico - White Label
 * 
 * Este arquivo centraliza dados estruturados como ofertas, planos,
 * FAQs, depoimentos e outros conteúdos dinâmicos.
 */

import images from './images';

const content = {
  // ============ OFERTAS DE PLANOS ============
  ofertas: [
    {
      id: 1,
      speed: 650,
      price: 999.99,
      header: 'Para sua empresa',
      seal: images.ofertas.carimboGratis,
      cardType: 'card-completo',
      benefits: [
        { 
          img: images.ofertas.apps.onigo, 
          alt: 'Onigo',
          width: 240,
        },
        {
          type: 'sideBySide',
          images: [
            { img: images.ofertas.apps.skyPlus, alt: 'Sky+' },
            { img: images.ofertas.apps.max, alt: 'Max' }
          ]
        },
        { 
          img: images.ofertas.apps.playkids, 
          alt: 'Playkids',
          width: 240,
        },
        { 
          img: images.ofertas.apps.deezer, 
          alt: 'Deezer',
          width: 240,
        },
      ],
      appChoices: [
        { img: images.ofertas.appsEscolha.estudaMais, alt: 'Estuda+' },
        { img: images.ofertas.appsEscolha.hub, alt: 'Hub' },
        { img: images.ofertas.appsEscolha.kaspersky, alt: 'Kaspersky' },
        { img: images.ofertas.appsEscolha.leitura360, alt: 'Leitura 360' },
      ],
      featured: true,
      popular: false,
    },
    {
      id: 2,
      speed: 500,
      price: 799.99,
      header: 'Para sua empresa',
      cardType: 'card-3-imagens',
      benefits: [
        { img: images.ofertas.apps.onigo, alt: 'Onigo', width: 240 },
        { img: images.ofertas.apps.playkids, alt: 'Playkids', width: 240 },
        { img: images.ofertas.apps.deezer, alt: 'Deezer', width: 240 },
      ],
      appChoices: [
        { img: images.ofertas.appsEscolha.estudaMais, alt: 'Estuda+' },
        { img: images.ofertas.appsEscolha.hub, alt: 'Hub' },
        { img: images.ofertas.appsEscolha.kaspersky, alt: 'Kaspersky' },
        { img: images.ofertas.appsEscolha.leitura360, alt: 'Leitura 360' },
      ],
      featured: false,
      popular: true,
    },
    {
      id: 3,
      speed: 350,
      price: 599.99,
      header: 'Para sua empresa',
      cardType: 'card-2-imagens',
      benefits: [
        { img: images.ofertas.apps.onigo, alt: 'Onigo', width: 240, marginTop: 40, marginBottom: 40 },
        { img: images.ofertas.apps.playkids, alt: 'Playkids', width: 240, marginTop: 40, marginBottom: 40 },
      ],
      appChoices: [
        { img: images.ofertas.appsEscolha.estudaMais, alt: 'Estuda+' },
        { img: images.ofertas.appsEscolha.hub, alt: 'Hub' },
        { img: images.ofertas.appsEscolha.kaspersky, alt: 'Kaspersky' },
        { img: images.ofertas.appsEscolha.leitura360, alt: 'Leitura 360' },
      ],
      featured: false,
      popular: false,
    },
    {
      id: 4,
      speed: 200,
      price: 399.99,
      header: 'Para sua empresa',
      cardType: 'card-2-imagens',
      benefits: [
        { img: images.ofertas.apps.onigo, alt: 'Onigo', width: 240, marginTop: 40, marginBottom: 40 },
        { img: images.ofertas.apps.deezer, alt: 'Deezer', width: 240, marginTop: 40, marginBottom: 40 },
      ],
      appChoices: [
        { img: images.ofertas.appsEscolha.estudaMais, alt: 'Estuda+' },
        { img: images.ofertas.appsEscolha.hub, alt: 'Hub' },
        { img: images.ofertas.appsEscolha.kaspersky, alt: 'Kaspersky' },
        { img: images.ofertas.appsEscolha.leitura360, alt: 'Leitura 360' },
      ],
      featured: false,
      popular: false,
    },
  ],

  // ============ FAQ - PERGUNTAS FREQUENTES ============
  faq: {
    internet: [
      {
        id: 'internet-1',
        question: 'O que é a fibra óptica da Oni?',
        answer: 'A fibra óptica da Oni é uma tecnologia de transmissão de dados que utiliza filamentos de vidro ou polímeros para transmitir informações através de pulsos de luz. Oferecemos conexões de até 1 Gbps com alta estabilidade e baixa latência, ideal para streaming, jogos online e trabalho remoto.',
      },
      {
        id: 'internet-2',
        question: 'Quais são os planos de internet disponíveis?',
        answer: 'A Oni oferece diversos planos de internet fibra óptica, começando com 300 Mbps por R$99,90/mês, 500 Mbps por R$129,90/mês e 1 Gbps por R$199,90/mês. Todos os planos incluem instalação gratuita, roteador Wi-Fi de última geração e suporte técnico 24/7.',
      },
      {
        id: 'internet-3',
        question: 'Como verificar a velocidade da minha internet?',
        answer: 'Você pode verificar a velocidade da sua internet através do nosso aplicativo Oni ou acessando o site speedtest.net. Para resultados mais precisos, recomendamos fazer o teste com o computador conectado diretamente ao roteador via cabo de rede.',
      },
      {
        id: 'internet-4',
        question: 'A Oni cobre meu endereço?',
        answer: 'A Oni está em constante expansão. Para verificar se seu endereço é atendido pela nossa rede de fibra óptica, acesse nosso site e informe seu CEP na página inicial ou entre em contato com nossa central de atendimento pelo 0800 888 9999.',
      },
    ],
    oniplay: [
      {
        id: 'oniplay-1',
        question: 'O que é o OniPlay?',
        answer: 'O OniPlay é nossa plataforma de streaming exclusiva que oferece acesso a filmes, séries, canais ao vivo e conteúdo sob demanda. Disponível para assinantes dos planos de internet da Oni, pode ser acessado em Smart TVs, smartphones, tablets e computadores.',
      },
      {
        id: 'oniplay-2',
        question: 'Como acessar o OniPlay?',
        answer: 'Para acessar o OniPlay, baixe o aplicativo na loja de aplicativos do seu dispositivo ou acesse play.oni.com.br. Faça login com os mesmos dados da sua conta Oni e comece a assistir imediatamente.',
      },
    ],
    oni5g: [
      {
        id: 'oni5g-1',
        question: 'Quais são os planos móveis da Oni?',
        answer: 'A Oni oferece planos móveis 4G e 5G com diferentes franquias de dados, começando com 5GB por R$39,90/mês até planos ilimitados por R$99,90/mês. Todos incluem ligações ilimitadas para qualquer operadora e WhatsApp sem consumir dados.',
      },
    ],
    dados: [
      {
        id: 'dados-1',
        question: 'Como alterar meus dados cadastrais?',
        answer: 'Para alterar seus dados cadastrais, acesse sua conta no site da Oni ou no aplicativo, vá até a seção "Meu Perfil" e selecione "Editar Informações". Após fazer as alterações necessárias, clique em "Salvar".',
      },
    ],
    planos: [
      {
        id: 'planos-1',
        question: 'Como mudar meu plano atual?',
        answer: 'Para alterar seu plano, acesse sua conta no site da Oni ou no aplicativo, vá até "Meus Serviços" e selecione "Alterar Plano". Você verá as opções disponíveis para upgrade ou downgrade. As alterações são processadas em até 24 horas.',
      },
    ],
    indicacao: [
      {
        id: 'indicacao-1',
        question: 'Como funciona o programa Indique um Amigo?',
        answer: 'No programa Indique um Amigo da Oni, você recebe R$50 de desconto na sua mensalidade para cada amigo que assinar um de nossos planos usando seu código de indicação. Seu amigo também ganha R$50 de desconto na primeira mensalidade.',
      },
    ],
    seguranca: [
      {
        id: 'seguranca-1',
        question: 'Como a Oni protege meus dados?',
        answer: 'A Oni utiliza tecnologias avançadas de criptografia e segurança para proteger seus dados pessoais, seguindo rigorosamente a Lei Geral de Proteção de Dados (LGPD). Realizamos auditorias de segurança regularmente e nunca compartilhamos suas informações com terceiros sem seu consentimento.',
      },
    ],
    aplicativos: [
      {
        id: 'aplicativos-1',
        question: 'Quais aplicativos estão disponíveis?',
        answer: 'Oferecemos diversos aplicativos parceiros como Estuda+, Hub, Kaspersky e Leitura 360. Você pode escolher até 2 aplicativos inclusos no seu plano sem custo adicional.',
      },
    ],
    suporte: [
      {
        id: 'suporte-1',
        question: 'Como entrar em contato com o suporte?',
        answer: 'Nosso suporte está disponível 24/7 através do telefone 0800 700 7072, WhatsApp (83) 97601-0064, chat no site ou app Oni. Também oferecemos suporte via e-mail em suporte@onitelecom.com.br.',
      },
    ],
  },

  // ============ DEPOIMENTOS ============
  depoimentos: [
    {
      id: 1,
      name: 'João Silva',
      location: 'João Pessoa - PB',
      rating: 5,
      text: 'A internet da Oni é excelente! Nunca tive problemas e o suporte é muito atencioso.',
      date: '2025-01-15',
      avatar: null,
    },
    {
      id: 2,
      name: 'Maria Santos',
      location: 'Cabedelo - PB',
      rating: 5,
      text: 'Melhor custo-benefício da região. Recomendo!',
      date: '2025-01-10',
      avatar: null,
    },
  ],

  // ============ BENEFÍCIOS ============
  beneficios: {
    internet: [
      {
        id: 1,
        icon: 'faWifi',
        title: 'Fibra Óptica',
        description: 'Tecnologia de ponta para máxima velocidade',
      },
      {
        id: 2,
        icon: 'faBolt',
        title: 'Alta Velocidade',
        description: 'Até 1 Gbps de velocidade garantida',
      },
      {
        id: 3,
        icon: 'faShield',
        title: 'Segurança',
        description: 'Proteção avançada contra ameaças',
      },
      {
        id: 4,
        icon: 'faHeadset',
        title: 'Suporte 24/7',
        description: 'Atendimento sempre disponível',
      },
    ],
  },

  // ============ CATEGORIAS DE APPS ============
  apps: {
    entretenimento: [
      { id: 'onigo', name: 'Oni Go', category: 'streaming' },
      { id: 'skyplus', name: 'Sky+', category: 'streaming' },
      { id: 'max', name: 'Max', category: 'streaming' },
      { id: 'playkids', name: 'Playkids', category: 'infantil' },
      { id: 'deezer', name: 'Deezer', category: 'musica' },
    ],
    educacao: [
      { id: 'estudamais', name: 'Estuda+', category: 'educacao' },
      { id: 'leitura360', name: 'Leitura 360', category: 'educacao' },
    ],
    seguranca: [
      { id: 'kaspersky', name: 'Kaspersky', category: 'seguranca' },
    ],
    outros: [
      { id: 'hub', name: 'Hub', category: 'outros' },
    ],
  },

  // ============ CARDS ENTRETENIMENTO ============
  cardsEntretenimento: {
    streamingMusica: [
      {
        id: 'deezer',
        name: 'DEEZER',
        price: '22,90',
        description: 'Streaming de áudio para mais música no seu dia-a-dia! Escute seus artistas, podcasts e playlists favoritos, descubra novos gostos, conheça os conteúdos exclusivos da Deezer e aproveite mais de 120 milhões de faixas do mundo todo.',
      },
    ],
    educacao: [
      {
        id: 'duolingo',
        name: 'DUOLINGO',
        price: '29,90',
        description: 'Aprenda idiomas de forma divertida e eficaz! O Duolingo oferece lições interativas, desafios diários e um sistema de gamificação para manter você motivado enquanto aprende uma nova língua.',
      },
    ],
    segurancaDigital: [
      {
        id: 'nordvpn',
        name: 'NORDVPN',
        price: '19,90',
        description: 'Proteja sua privacidade online com o NordVPN. Navegue com segurança, acesse conteúdo bloqueado geograficamente e mantenha seus dados pessoais protegidos com criptografia de nível militar.',
      },
    ],
    saudeBemEstar: [
      {
        id: 'calm',
        name: 'CALM',
        price: '34,90',
        description: 'Melhore seu bem-estar mental com o Calm. Acesse meditações guiadas, histórias para dormir, músicas relaxantes e exercícios de respiração para reduzir o estresse e melhorar a qualidade do seu sono.',
      },
    ],
  },

  // ============ CARRINHO - DADOS DOS CARDS ============
  carrinho: {
    planos: [
      {
        id: 'plano1',
        name: 'Plano Básico',
        description: 'Internet 300 Mbps + Telefonia Fixa',
        price: 119.90,
        image: 'https://images.unsplash.com/photo-1544197150-b99a580bb7a8?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
        badge: 'Mais Vendido',
      },
      {
        id: 'plano2',
        name: 'Plano Intermediário',
        description: 'Internet 500 Mbps + Telefonia Fixa + Streaming',
        price: 149.90,
        image: 'https://images.unsplash.com/photo-1534949752991-a065b0f5dfaa?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
      },
      {
        id: 'plano3',
        name: 'Plano Premium',
        description: 'Internet 1 Gbps + Telefonia Fixa + Streaming + TV',
        price: 199.90,
        image: 'https://images.unsplash.com/photo-1563770660941-10a63a9df3e4?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
        badge: 'Premium',
      },
    ],
    internet: [
      {
        id: 'internet1',
        name: 'Fibra 300 Mbps',
        description: 'Internet de alta velocidade com fibra óptica',
        price: 99.90,
        image: 'https://images.unsplash.com/photo-1544197150-b99a580bb7a8?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
      },
      {
        id: 'internet2',
        name: 'Fibra 500 Mbps',
        description: 'Internet ultra rápida para toda a família',
        price: 129.90,
        image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
        badge: 'Recomendado',
      },
      {
        id: 'internet3',
        name: 'Fibra 1 Gbps',
        description: 'A internet mais rápida do mercado',
        price: 179.90,
        image: 'https://images.unsplash.com/photo-1614064641938-3bbee52942c7?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
        badge: 'Ultra Rápido',
      },
    ],
    telefonia: [
      {
        id: 'tel1',
        name: 'Linha Fixa Residencial',
        description: 'Telefone fixo com tarifas reduzidas',
        price: 39.90,
        image: 'https://images.unsplash.com/photo-1545128485-c400e7702796?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
      },
      {
        id: 'tel2',
        name: 'Pacote Empresarial',
        description: 'Múltiplas linhas com recursos avançados',
        price: 69.90,
        image: 'https://images.unsplash.com/photo-1576267423445-b2e0074d68a4?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
        badge: 'Empresarial',
      },
      {
        id: 'tel3',
        name: 'VoIP Avançado',
        description: 'Telefonia via internet com recursos de call center',
        price: 89.90,
        image: 'https://images.unsplash.com/photo-1595079676339-1534801ad6cf?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
      },
    ],
    entretenimento: [
      {
        id: 'ent1',
        name: 'Streaming de Filmes',
        description: 'Acesso a filmes e séries exclusivas',
        price: 49.90,
        image: 'https://images.unsplash.com/photo-1522869635100-9f4c5e86aa37?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
      },
      {
        id: 'ent2',
        name: 'Pacote de Canais',
        description: 'Mais de 200 canais HD',
        price: 79.90,
        image: 'https://images.unsplash.com/photo-1593784991095-a205069470b6?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
        badge: 'Popular',
      },
      {
        id: 'ent3',
        name: 'Pacote Completo',
        description: 'Todos os canais + Streaming Premium',
        price: 119.90,
        image: 'https://images.unsplash.com/photo-1574375927938-d5a98e8ffe85?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
      },
    ],
  },

  // ============ DEPOIMENTOS EMPRESAS ============
  depoimentosEmpresas: [
    {
      id: 1,
      texto: 'A Oni Telecom transformou nossa infraestrutura de comunicação. A internet de alta velocidade e o sistema de telefonia na nuvem aumentaram significativamente nossa produtividade.',
      autor: 'Maria Silva',
      cargo: 'CEO da Empresa XYZ',
    },
  ],

  // ============ HELP SECTION - CARDS ============
  helpSection: [
    {
      id: 'faq',
      title: 'Perguntas Frequentes',
      description: 'Encontre respostas rápidas para suas dúvidas mais comuns',
      buttonText: 'Explorar FAQs',
      link: '/perguntasfrequentes',
    },
    {
      id: 'atendimento',
      title: 'Atendimento',
      description: 'Fale diretamente com nossa equipe de suporte dedicada',
      buttonText: 'Iniciar Chat',
      link: 'whatsapp', // Indica uso do link do WhatsApp
    },
    {
      id: 'planos',
      title: 'Nossos Planos',
      description: 'Descubra o plano perfeito para suas necessidades',
      buttonText: 'Ver Planos',
      link: '/Planos',
    },
  ],

  // ============ OFERTAS CHIPS - PLANOS MÓVEIS ============
  ofertasChips: [
    {
      nome: 'Plano Básico',
      features: [
        { icon: 'faWifi', text: '5GB de Internet' },
        { icon: 'faPhone', text: '100 minutos' },
        { icon: 'faCommentAlt', text: '100 SMS' },
      ],
      preco: 'R$ 29,99/mês',
      imagensCount: 1,
    },
    {
      nome: 'Plano Intermediário',
      features: [
        { icon: 'faWifi', text: '10GB de Internet' },
        { icon: 'faPhone', text: '200 minutos' },
        { icon: 'faCommentAlt', text: '200 SMS' },
      ],
      preco: 'R$ 49,99/mês',
      imagensCount: 2,
    },
    {
      nome: 'Plano Premium',
      features: [
        { icon: 'faWifi', text: '20GB de Internet' },
        { icon: 'faPhone', text: 'Ligações Ilimitadas' },
        { icon: 'faCommentAlt', text: 'SMS Ilimitados' },
      ],
      preco: 'R$ 79,99/mês',
      imagensCount: 3,
      destaque: 'Popular',
    },
    {
      nome: 'Plano Família',
      features: [
        { icon: 'faWifi', text: '30GB de Internet' },
        { icon: 'faPhone', text: 'Ligações Ilimitadas' },
        { icon: 'faCommentAlt', text: 'SMS Ilimitados' },
        { icon: 'faUsers', text: 'Até 4 linhas' },
      ],
      preco: 'R$ 129,99/mês',
      imagensCount: 1,
    },
    {
      nome: 'Plano Estudante',
      features: [
        { icon: 'faWifi', text: '15GB de Internet' },
        { icon: 'faPhone', text: '150 minutos' },
        { icon: 'faCommentAlt', text: 'SMS Ilimitados' },
        { icon: 'faGraduationCap', text: 'Acesso a plataformas educacionais' },
      ],
      preco: 'R$ 59,99/mês',
      imagensCount: 2,
    },
    {
      nome: 'Plano Empresarial',
      features: [
        { icon: 'faWifi', text: '50GB de Internet' },
        { icon: 'faPhone', text: 'Ligações Ilimitadas' },
        { icon: 'faCommentAlt', text: 'SMS Ilimitados' },
        { icon: 'faBriefcase', text: 'Suporte prioritário' },
      ],
      preco: 'R$ 199,99/mês',
      imagensCount: 3,
    },
    {
      nome: 'Plano Gamer',
      features: [
        { icon: 'faWifi', text: '100GB de Internet' },
        { icon: 'faPhone', text: 'Ligações Ilimitadas' },
        { icon: 'faGamepad', text: 'Prioridade em jogos online' },
        { icon: 'faTachometerAlt', text: 'Baixa latência' },
      ],
      preco: 'R$ 149,99/mês',
      imagensCount: 1,
    },
    {
      nome: 'Plano Ilimitado Plus',
      features: [
        { icon: 'faInfinity', text: 'Internet Ilimitada' },
        { icon: 'faPhone', text: 'Ligações Ilimitadas' },
        { icon: 'faCommentAlt', text: 'SMS Ilimitados' },
        { icon: 'faGlobe', text: 'Roaming internacional' },
      ],
      preco: 'R$ 249,99/mês',
      imagensCount: 2,
      destaque: 'Novo',
    },
  ],

  // ============ POR QUE ESCOLHER - RECURSOS ============
  porQueEscolher: [
    {
      icon: 'faUserTie',
      titulo: 'Atendimento Personalizado',
      descricao: 'Conte com um gerente de conta dedicado para atender às necessidades específicas da sua empresa.',
    },
    {
      icon: 'faCogs',
      titulo: 'Soluções Integradas',
      descricao: 'Simplifique sua gestão de telecom com nossas soluções completas e integradas.',
    },
    {
      icon: 'faHeadset',
      titulo: 'Suporte 24/7',
      descricao: 'Suporte técnico especializado disponível 24 horas por dia, 7 dias por semana.',
    },
  ],

  // ============ SERVIÇOS ============
  servicos: [
    {
      icon: 'faGlobe',
      titulo: 'Internet Empresarial',
      descricao: 'Conexão rápida e estável para manter sua empresa sempre online.',
      recursos: [
        'Fibra óptica de última geração',
        'Planos dedicados com garantia de banda',
        'Suporte técnico 24/7',
      ],
    },
    {
      icon: 'faPhoneAlt',
      titulo: 'Telefonia Empresarial',
      descricao: 'Comunicação clara e eficiente para sua equipe e clientes.',
      recursos: [
        'PABX na nuvem',
        'Ramais ilimitados',
        'Integração com CRM',
      ],
    },
    {
      icon: 'faMobileAlt',
      titulo: 'Mobilidade Corporativa',
      descricao: 'Mantenha sua equipe conectada em qualquer lugar.',
      recursos: [
        'Planos corporativos flexíveis',
        'Gestão online de linhas',
        'Roaming internacional',
      ],
    },
    {
      icon: 'faTv',
      titulo: 'TV Corporativa',
      descricao: 'Informação e entretenimento para sua empresa e clientes.',
      recursos: [
        'Canais corporativos personalizados',
        'Pacotes de notícias e negócios',
        'Soluções para hotéis e academias',
      ],
    },
    {
      icon: 'faVideo',
      titulo: 'Sistemas de Segurança',
      descricao: 'Proteção avançada para seu patrimônio e colaboradores.',
      recursos: [
        'Câmeras IP de alta definição',
        'Armazenamento em nuvem',
        'Acesso remoto via aplicativo',
      ],
    },
  ],

  // ============ SERVIÇOS ESSENCIAIS ============
  servicosEssenciais: [
    {
      href: 'https://api.whatsapp.com/send/?phone=5583976010064&text&type=phone_number&app_absent=0',
      imgKey: 'img1',
      text: 'Consulte sua fatura',
    },
    {
      href: 'https://api.whatsapp.com/send/?phone=5583976010064&text&type=phone_number&app_absent=0',
      imgKey: 'img2',
      text: 'Tire suas dúvidas',
    },
    {
      href: 'https://api.whatsapp.com/send/?phone=5583976010064&text&type=phone_number&app_absent=0',
      imgKey: 'img3',
      text: 'Fale conosco',
    },
    {
      href: 'https://api.whatsapp.com/send/?phone=5583976010064&text&type=phone_number&app_absent=0',
      imgKey: 'img4',
      text: 'Faça uma recarga',
    },
  ],

  // ============ SERVIÇOS ESSENCIAIS INTERNET ============
  servicosEssenciaisInternet: [
    {
      imgKey: 'img1',
      alt: 'Fibra Óptica',
      titulo: 'CONEXÃO 100% FIBRA ÓPTICA',
      descricao: 'Experimente velocidades ultrarrápidas e estabilidade incomparável com nossa rede de fibra óptica de ponta a ponta.',
    },
    {
      imgKey: 'img2',
      alt: 'Roteador Wi-Fi',
      titulo: 'ROTEADOR WI-FI DUAL BAND',
      descricao: 'Desfrute de uma cobertura Wi-Fi ampla e potente em toda sua casa com nosso roteador de última geração.',
    },
    {
      imgKey: 'img3',
      alt: 'Suporte',
      titulo: 'SUPORTE TÉCNICO AVANÇADO',
      descricao: 'Conte com nossa equipe de especialistas 24/7 para resolver qualquer problema e otimizar sua conexão.',
    },
    {
      imgKey: 'img4',
      alt: 'Equipe Especializada',
      titulo: 'EQUIPE ESPECIALIZADA',
      descricao: 'Nossos profissionais altamente treinados garantem a melhor experiência em instalação e manutenção.',
    },
  ],
};

/**
 * Função para obter ofertas filtradas
 */
export const getOfertas = (filters = {}) => {
  let ofertas = [...content.ofertas];
  
  if (filters.featured) {
    ofertas = ofertas.filter(o => o.featured);
  }
  
  if (filters.popular) {
    ofertas = ofertas.filter(o => o.popular);
  }
  
  if (filters.maxPrice) {
    ofertas = ofertas.filter(o => o.price <= filters.maxPrice);
  }
  
  if (filters.minSpeed) {
    ofertas = ofertas.filter(o => o.speed >= filters.minSpeed);
  }
  
  return ofertas;
};

/**
 * Função para obter FAQ por categoria
 */
export const getFAQByCategory = (category) => {
  return content.faq[category] || [];
};

/**
 * Função para buscar em FAQ
 */
export const searchFAQ = (searchTerm) => {
  const results = [];
  const term = searchTerm.toLowerCase();
  
  Object.keys(content.faq).forEach(category => {
    content.faq[category].forEach(item => {
      if (
        item.question.toLowerCase().includes(term) ||
        item.answer.toLowerCase().includes(term)
      ) {
        results.push({ ...item, category });
      }
    });
  });
  
  return results;
};

export default content;
